import React from 'react'
import PropTypes from 'prop-types'

import { InformationBoxBase, Title, Row } from './styles'

const InformationBox = ({ text, icon, title, status }) => {
  return (
    <InformationBoxBase status={status}>
      <Title status={status}>
        {icon}
        {title}
      </Title>
      <Row status={status}>{text}</Row>
    </InformationBoxBase>
  )
}

InformationBox.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.instanceOf(Object),
  title: PropTypes.string,
  status: PropTypes.string,
}

export default InformationBox
